import { api } from '../../../helpers'
import { storage, swal } from '../../../libraries'
import { appConstants } from '../../../constants'

export const loginFetch = (email, password) => {
  return dispatch => {
    dispatch(loginRequest())
    const user = {
      email: email,
      password: password
    }
    api.post('auth/signin', user)
      .then((res) => {
        const { data: dataUser, token, success } = res.data
        if (success === true) {
          storage.setItem('token', JSON.stringify(token))
          // api.defaults.headers.common['app-token'] = JSON.parse(storage.getItem('app-token'))
          dispatch(loginSuccess(dataUser))
          swal({
            title: 'Berhasil Login',
            text: res.data.message.replace(new RegExp(/\\r|\\n/g), ''),
            icon: 'success',
            button: true 
          })
        } else {
          storage.removeItem('token')
          swal({
            title: 'Gagal Login',
            text: res.data.message.replace(new RegExp(/\\r|\\n/g), ''),
            icon: 'error',
            button: true  
          })
        } 
      })
      .catch((message) => console.error(message))
  }
}

const loginRequest = () => ({
  type: appConstants.LOGIN_REQUEST
})

const loginSuccess = (dataUser, message) => ({
  type: appConstants.LOGIN_SUCCESS,
  payload: { dataUser, message } 
})

export const logoutUser = () => ({
  type: appConstants.LOGOUT_USER
})
